export default __webpack_public_path__ + "static/media/regardBrulant.8f9623ba.png";